module.exports = require("live/services/service-locator");